import * as React from 'react';
import { FC, useState } from 'react';

import { useIntl } from 'react-intl';

import Toggle from 'components/toggle';
import { useSetLoyaltyDonationUpchargeMutation } from 'generated/rbi-graphql';
import useRoutes from 'hooks/use-routes';
import { CustomEventNames, EventTypes, useMParticleContext } from 'state/mParticle';

import {
  Container,
  Description,
  StyledLink,
  Text,
  Title,
  ToggleContainer,
} from './round-up-toggle.styled';
import { IRoundUpToggleProps } from './types';

/**
 *
 * Round Up Toggle Component
 *
 */

const RoundUpToggle: FC<IRoundUpToggleProps> = ({ cardId, donationStatus }) => {
  const { formatMessage } = useIntl();
  const { getLocalizedRouteForPath } = useRoutes();
  const { logEvent } = useMParticleContext();
  const [toggle, setToggle] = useState<boolean>(donationStatus);
  const [setLoyaltyDonationUpchargeMutation, { loading }] = useSetLoyaltyDonationUpchargeMutation({
    onCompleted: result => {
      const donationUpchargeResult = result.setLoyaltyDonationUpcharge?.donationUpcharge ?? false;
      setToggle(donationUpchargeResult);

      logEvent(CustomEventNames.TH_ROUND_UP_STATUS_TOGGLE, EventTypes.UserPreference, {
        loyaltyCardId: cardId,
        donationStatus: donationUpchargeResult,
      });
    },
  });

  const roundUpUpdate = async () => {
    return await setLoyaltyDonationUpchargeMutation({
      variables: {
        cardId,
        donationUpcharge: !toggle,
      },
    });
  };

  return (
    <Container data-testid="round-up-toggle-container">
      <Title>
        <Text>{formatMessage({ id: 'roundUpTitle' })}</Text>
        <ToggleContainer>
          <Toggle
            disabled={loading}
            checked={toggle}
            data-testid="round-up-toggle"
            onChange={roundUpUpdate}
          />
        </ToggleContainer>
      </Title>
      <Description>
        {formatMessage(
          { id: 'roundUpDescription' },
          {
            link: (
              <StyledLink
                data-testid="tims-rewards-faq-link"
                to={getLocalizedRouteForPath('tims-rewards-faq')}
              >
                {formatMessage({ id: 'timsRewardsFaqLinkText' })}
              </StyledLink>
            ),
          }
        )}
      </Description>
    </Container>
  );
};

export default RoundUpToggle;
